/**
 * Input Schema of PanelUser
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {PanelUser} from '@/model/resource/PanelUser'
import InputDocumentPanelUser from '@/components/InputDocumentPanelUser.vue'
import {debounce} from 'lodash'
import {Responsavel} from '@/model/resource/Responsavel'
import {VisualizationModeCollection} from '@/model/collection/VisualizationModeCollection'

/* TODO: review generated schema */

export class InputPanelUserSchema extends Schema {
  collectionVisualizationMode = new VisualizationModeCollection().noPagination()

  firstFields = [
    'document',
    'corporateName',
    'contactName',
    'telephone',
    'email',
    'dueDate',
  ]

  formUpdateExpiringDate = ['dueDate']
  readonly name = 'InputPanelUser'

  readonly fieldSet: FieldSet<PanelUser> = {
    document: (schema): FieldComponent => ({
      is: InputDocumentPanelUser,
      bind: {
        model: schema.model,
        label: this.translateFrom(schema.fieldName),
      },
      on: {
        inputDocument: async () => {},
      },
    }),
    corporateName: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        inputClass: 'uppercase',
        validation: 'max:255|required',
      },
    }),
    contactName: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        required: true,
        inputClass: 'uppercase',
        label: this.translateFrom(schema.fieldName),
        validation: 'max:255|required',
      },
    }),
    telephone: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        required: true,
        maxlength: 25,
        label: this.translateFrom(schema.fieldName),
        validation: 'max:25|required',
      },
    }),
    email: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        inputClass: 'uppercase',
        type: 'email',
        required: true,
        label: this.translateFrom(schema.fieldName),
        validation: 'max:255|email|required',
      },
    }),
    dueDate: (schema): FieldComponent => ({
      is: Component.InputDate,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    visualizationMode: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionVisualizationMode.all(),
        required: true,
        validation: 'required',
      },
    }),
  }
}
